<template>
  <div class="mask-layer mask">
    <div class="container">
      <div class="title">
        选择审批领导
      </div>
      <div class="content">
        <div class="search-box">
          <!-- <form @submit.prevent="submit"> -->
            <div class="select-wrap">
              <div class="group margin-right-15">
                <span class="left">搜索姓名</span>
                <div class="right">
                  <input type="text" placeholder="请输入审批领姓名导" v-model.trim="model.name">
                </div>
              </div>
              <div class="group btn-box">
                <button type="submit" class="btn" @click="search">搜索</button>
                <button type="button" class="btn" @click="reset">重置</button>
                <button type="button" @click="choose" class="btn">确认选择</button>
              </div>
            </div>
          <!-- </form> -->
        </div>
        <div class="main_wrap">
          <div class="table_wrap">
            <div class="table_layout">
              <div class="table_scroll ">
                <el-table
                  ref="elTable"
                  :data="dataList"
                  max-height="534"
                  border
                  :cell-style="cellStyle"
                  style="width: 100%"
                  :header-cell-style="tableHeaderColor"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    width="60">
                  </el-table-column>
                  <el-table-column
                    label="姓名"
                    min-width="60"
                    key="1"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{scope.row.realname}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="手机号"
                    min-width="100"
                    key="2"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{scope.row.phone}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="小程序id"
                    min-width="100"
                    key="3"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <!--<span class="primary pointer mr15" >选择</span>-->
                      {{scope.row.miniOpenId}}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!--<div v-if="!dataList.length">-->
                <!--<nt-no-data></nt-no-data>-->
              <!--</div>-->
              <!--<div class="pagination insurancePage" v-if="dataList.length">-->
                <!--<nt-pagination ref="child" @fetchData="fetchData"></nt-pagination>-->
              <!--</div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <!--<button type="button" class="btn mr20" @click="submitInfo">发送</button>-->
        <button type="button" class="btn" @click="close">取消</button>
      </div>
      <div class="close" @click="close">X</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: "leader",
    // props:['sendData'],
    props: ['namesIds'],
    data() {
      return {
        model:{
          value1: '',
          id:null,//id
          // roleName:null,//角色名称
          // projectId:null,//所属系统id
          // ruleCode:null,//角色编码
          // status:null,//是否启用
          // remark:null,//备注
          phone:null,
          realname:null,
          miniOpenId:null,
          name: null,
        },
        radio:'1',
        projectList:[],
        dataList: null,
        oldDataList: null,
        currentPage4: 4,
        leaderShow:false,
        tableDataAmount:null,
        select:[],
        selectName:[],
        selects:null,
        selectId:[]
      }
    },
    mounted() {
      this.getleaderList()
    },
    computed:{
    },
    methods: {
      getleaderList(){
        this.$axios.get('/admin/user/leaderList').then(res=>{
          this.dataList = res.data.data
          this.oldDataList = res.data.data
          console.log(this.namesIds)
          if(this.namesIds != null) {
            let ids = this.namesIds.split(",")
            let selectArr = []
            this.$nextTick(function() {
              this.dataList.forEach(n => {
                ids.forEach(m => {
                  if(m == n.id) {
                    selectArr.push(n)
                    this.$refs.elTable.toggleRowSelection(n, true)
                  }
                })
              })
            })
          }
        })
      },
      handleSelectionChange(data){
        this.tableDataAmount = data
      },
      choose(){
        if(this.tableDataAmount){
          // let select = this.tableDataAmount
          this.tableDataAmount.forEach(item=>{
            this.select.push(item.id)

          })
          this.dataList.forEach(item=>{
            let items = item
            console.log(items)
            this.tableDataAmount.forEach(item=>{
              if(items.id  == item.id){
                this.selectName.push(items.realname)
                this.selectId.push(items.id)
                let realname=this.selectName.toString()
                let realid=this.selectId.toString()
                this.selects={
                  realname, realid
                }
                console.log(this.selects,'this.selects')
                console.log(JSON.stringify(this.selects))
                this.$emit('func',JSON.stringify(this.selects))
              }
            })
          })
        }



      },
      fetchData(args) {
      },
      cellStyle({row, column, rowIndex, columnIndex}){
        return 'height:20px;font-size:12px';
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return 'background-color: #f4f5f7;height:40px;color:#4a4a4a!important;font-size:13px'
        }
      },
      // handleSelectionChange(val) {
      //   // this.multipleSelection = val;
      //   val.forEach(item=>{
      //     if(item.range){
      //       item.range=parseFloat(item.range)
      //     }
      //   })
      //   console.log(val)
      //   this.model.rule.accidentRanges=val;
      // },
      close(){
        this.$emit('func', this.leaderShow);
      },
      submitInfo(){
        this.$validator
          .validateAll()
          .then((result) => {
            if (result) {
              this.save();
            }
          })
          .catch(err => {
          });
      },
      save(){
        var msg;
        if(this.sendData.id){
          msg="编辑成功";
        }else{
          msg="新增成功";
        }
        this.$axios.post('/rm-user-manage/api/admin/role/set',this.model).then(res=>{
          let data=this.AppUtils.checkResponse(res);
          if(data){
            console.log(data)
            if(data.code==0){
              this.$message.success(msg);
              this.$emit('hideEditMask');
              this.$emit('fetchData');
            }
          }
        });
      },
      search() {
        console.log(this.model.name)
        let newArr = this.dataList.filter(item => {
          return item.realname == this.model.name;
        })
        this.dataList = newArr;
      },
      reset() {
        this.model.name = null;
        this.dataList = this.oldDataList;
      },

    }
  }
</script>

<style scoped lang="scss">
  /*@import '../../assets/css/cover.css';*/
  .systemUl{
    display: flex;
    .systemLi{
      width: 100px;
      line-height: 30px;
      text-align: center;

    }
  }
  .reset{
    position: relative;
    left: -30px;
  }
  .mask-layer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .form_item{
    display: flex;
    justify-content: center;
    /*margin-bottom: 15px;*/
  }
  .form_left{
    line-height: 32px;
    margin-right: 10px;
  }
  .form_right{
    line-height: 32px;
    width: 200px!important;
    box-sizing: border-box;
    padding-left: 10px;
    text-align: left;
    height: 45px;
  }
  .container {
    background-color: #fff;
    width: 800px;
    box-sizing: border-box;
    padding-bottom: 10px;
    max-height: 650px;
    position: relative;
    overflow-y: scroll;
    .close{
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 14px;
      position: absolute;
      top: 10px;
      right: 5px;
      cursor: pointer;
    }
    .title{
      height: 41px;
      line-height:41px;
      box-sizing: border-box;
      padding-left: 16px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #4A4A4A;
      text-align: left;
      border-bottom: 1px solid #ECF1F4;
    }
    .content{
      padding: 16px;
      box-sizing: border-box;
      .topInfo{
        display: flex;
        justify-content: left;
        margin-bottom: 27px;
        span{
          line-height: 21px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #000000;
        }
      }
      .sendInfo{
        display: flex;
        justify-content: left;
        margin-bottom: 10px;
        span{
          line-height: 21px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #000000;
        }
      }
      .infoZone{
        width: 568px;
        height: 250px;
        border: 1px solid #D7D7D7;
        border-radius: 2px;
        position: absolute;
        text-align: left;
        box-sizing: border-box;
        padding: 11px 20px;
        p{
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4A4A4A;
          a{
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #FF4C00;
          }
        }
        .p1{
          margin-bottom:25px ;
        }
        .p2{
          margin-bottom:11px ;
        }
        .p3{
          margin-bottom:7.5px ;
        }
        textarea{
          position: absolute;
          left: 0;
          top: 0px;
          width: 100%;
          height: 100%;
          resize: none;
          box-sizing: border-box;
          /*padding: 0px 22px;*/
        }
        button{
          position: absolute;
          right:14px ;
          bottom: 9.5px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #FFFFFF;
          background: #1038B7;
          border-radius: 2px;
          padding: 2px 12px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// leader.vue?b5105bca